import React from "react";

export default function PageHero({ tag, title, subtitle, image }) {
  return (
    <section className={`page-hero ${image ? "with-image" : ""}`} data-testid="page-hero">
      {image ? <img className="page-hero-bg" src={image} alt="" aria-hidden="true" /> : null}
      {tag ? <p className="section-tag">{tag}</p> : null}
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      {subtitle ? <p>{subtitle}</p> : null}
    </section>
  );
}
